import { authGetAll } from '../../http';

export const getBSolutionsWebSSORedirectUrl = async () => {
  return await authGetAll('api/v1/integrations/bsolutionsweb/sso/redirect');
};